import type { CachXuLyKenhLo, Nhom } from '@qlk/shared';
import { CACH_XU_LY_KENH_LO, CACH_XU_LY_KENH_LO_LABEL } from '@qlk/shared';
import { useState } from 'react';

import { HopThoai, MAU_DU_LIEU_MAC_DINH, Nut, O, OChonTruong } from '../../../ui/index.js';
import { useLuuNhom } from '../api.js';

export interface HopNhomProps {
  /** Không truyền = tạo nhóm mới. */
  nhom?: Nhom;
  onDong: () => void;
}

export function HopNhom({ nhom, onDong }: HopNhomProps) {
  const luu = useLuuNhom();

  const [name, setName] = useState(nhom?.name ?? '');
  const [color, setColor] = useState(nhom?.color ?? MAU_DU_LIEU_MAC_DINH);
  const [note, setNote] = useState(nhom?.note ?? '');
  const [chinhSach, setChinhSach] = useState<CachXuLyKenhLo>(
    nhom?.chinhSachKenhLo ?? 'chia_theo_thuc_nhan',
  );
  const [quanLyNhapChiPhi, setQuanLy] = useState(nhom?.quanLyNhapChiPhi ?? true);

  const hopLe = name.trim().length > 0;

  return (
    <HopThoai
      title={nhom ? 'Sửa nhóm' : 'Tạo nhóm'}
      rong="md"
      onDong={onDong}
      chanHop={
        <>
          {luu.isError && (
            <p role="alert" className="mr-auto self-center text-phu text-bad-chu">
              {luu.error.message}
            </p>
          )}
          <Nut kieu="phu" onClick={onDong}>
            Huỷ
          </Nut>
          <Nut
            kieu="chinh"
            disabled={!hopLe}
            dangChay={luu.isPending}
            onClick={() => {
              luu.mutate(
                {
                  ...(nhom ? { id: nhom.id } : {}),
                  name: name.trim(),
                  color,
                  note: note.trim() || null,
                  chinhSachKenhLo: chinhSach,
                  quanLyNhapChiPhi,
                },
                { onSuccess: onDong },
              );
            }}
          >
            Lưu
          </Nut>
        </>
      }
    >
      <div className="space-y-4">
        <O label="Tên nhóm" value={name} onChange={setName} required />
        <O label="Màu" type="color" value={color} onChange={setColor} />
        <O label="Ghi chú" value={note} onChange={setNote} nhieuDong />

        <OChonTruong
          label="Chính sách khi kênh lỗ"
          value={chinhSach}
          onChange={(v) => {
            setChinhSach(v as CachXuLyKenhLo);
          }}
          options={CACH_XU_LY_KENH_LO.map((c) => ({
            value: c,
            label: CACH_XU_LY_KENH_LO_LABEL[c],
          }))}
          moTa="Áp cho mọi kênh trong nhóm; từng kênh ghi đè được ở tab Đội ngũ & chia sẻ"
        />

        <label className="flex items-center gap-2 text-co-ban text-chu">
          <input
            type="checkbox"
            checked={quanLyNhapChiPhi}
            onChange={(e) => {
              setQuanLy(e.target.checked);
            }}
            className="h-4 w-4"
          />
          Cho quản lý kênh tự nhập chi phí kênh mình
        </label>
      </div>
    </HopThoai>
  );
}
